export default "__VITE_ASSET__DKZYLOtD__"